import React from "react";
import { PublicLayoutTemplate } from "themes/common/layouts";

function PublicLayout(props) {
    return <PublicLayoutTemplate {...props} />;
}

export default PublicLayout;
